/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as erc1967 from "./ERC1967";
export * as beacon from "./beacon";
export * as transparent from "./transparent";
export { Proxy__factory } from "./Proxy__factory";
